import { render } from "./Research.vue?vue&type=template&id=034b941c&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=034b941c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-034b941c"

export default script